import { render, staticRenderFns } from "./voteDetail.vue?vue&type=template&id=6c0cd732&scoped=true&"
import script from "./voteDetail.vue?vue&type=script&lang=js&"
export * from "./voteDetail.vue?vue&type=script&lang=js&"
import style0 from "./voteDetail.vue?vue&type=style&index=0&id=6c0cd732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0cd732",
  null
  
)

export default component.exports